import { useExperimentTreatmentWithoutReporting } from '../experiments';
import { useFeatureAccessSettings } from '../featureAccessSettings';

export const useIsQnAMyInsightsEntryPointVisible = (): boolean => {
  const isVivaAnswersEnabled = useExperimentTreatmentWithoutReporting('AnswersInVivaGA') === true;
  const viewerCanAccessNetworkQuestions = useFeatureAccessSettings()?.viewerCanAccessNetworkQuestions;

  return isVivaAnswersEnabled && viewerCanAccessNetworkQuestions === true;
};
